/*       */

import { gql } from '@apollo/client';

import { defaultPipelineQueryFields } from './pipelineQuery';

export default gql`
	mutation connectorStartPipelineMutation($id: ID!, $connectorLabel: String!){
		result: iotPipelineConnectorStart(id: $id, connectorLabel: $connectorLabel) {
			${defaultPipelineQueryFields}
		}
	}
`;
